import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-induction-modules-edit',
  templateUrl: './induction-modules-edit.component.html',
  styleUrls: ['./induction-modules-edit.component.scss']
})
export class InductionModulesEditComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
